class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
		
		// Event delegation kullanarak clear cart button'ı dinle
		// Bu şekilde DOM güncellendiğinde de çalışır
		this.addEventListener('click', this.handleClearCartClick.bind(this));

		subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
			//this.fetchAndUpdateCart();
			// setClearCartButton artık gerekli değil, event delegation kullanıyoruz
		});
	}

	async fetchAndUpdateCart() {
		try {
			// Root path kullanarak section'ları çek (her sayfada çalışır)
			const sectionsUrl = window.Shopify?.routes?.root || '/';
			const response = await fetch(`${sectionsUrl}?sections=cart-drawer,cart-icon-bubble`);
			const data = await response.json();

			this.getSectionsToRender().forEach((section) => {
				const sectionElement = section.selector
					? document.querySelector(section.selector)
					: document.getElementById(section.id);
				
				if (sectionElement && data[section.id]) {
					sectionElement.innerHTML = this.getSectionInnerHTML(
						data[section.id],
						section.selector
					);
				}
			});

			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);

			// Clear cart button için event delegation zaten aktif, ekstra işlem gerekmez
		} catch (error) {
			console.error('Error updating cart:', error);
		}
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");

		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});

		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);

		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("cart-overflow-hidden");

		if (!isSafari()) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.add("overflow-clip");
		}
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("cart-overflow-hidden");

		if (!isSafari()) {
			document.body.classList.remove("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-clip");
		}

		setTimeout(() => {
			let notification = this.querySelector(".notification");

			if (notification) {
				const activeItem = this.querySelector(
					`.cart-item[data-product-id="${this.productId}"`
				);
				notification.classList.remove("notification-open");
				activeItem?.classList.remove("active");
			}
		}, 1000);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		let notification = this.querySelector(".notification");

		if (notification) {
			const activeItem = this.querySelector(
				`.cart-item[data-product-id="${this.productId}"`
			);
			notification.classList.add("notification-open");
			activeItem.classList.add("active");
		}

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			// Clear cart button için event delegation zaten aktif, ekstra işlem gerekmez
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}

	handleClearCartClick(event) {
		// Event delegation: clear cart button'a tıklanıp tıklanmadığını kontrol et
		const clearButton = event.target.closest('.cart-remove-all-button button');
		if (!clearButton) return;

		event.preventDefault();
		this.clearCart(clearButton);
	}

	async clearCart(clearButton) {
		try {
			clearButton.disabled = true;
			const buttonText = clearButton.querySelector('span');
			if (buttonText) {
				buttonText.textContent = 'Temizleniyor...';
			}
			
			const response = await fetch('/cart/clear.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response.ok) {
				// Cart'ı direkt güncelle
				await this.fetchAndUpdateCart();
			} else {
				console.error('Cart clear failed:', response);
				clearButton.disabled = false;
				if (buttonText) {
					buttonText.textContent = 'Sepeti Temizle';
				}
			}
		} catch (error) {
			console.error('Error clearing cart:', error);
			clearButton.disabled = false;
			const buttonText = clearButton.querySelector('span');
			if (buttonText) {
				buttonText.textContent = 'Sepeti Temizle';
			}
		}
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}

class ProductRecommendationsDrawer extends HTMLElement {
	constructor() {
		super();
	}

	fetchProducts() {
		if (!this.dataset.url) return;

		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations-drawer');
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
					this.initSwiper();
				}

				this.classList.add('cart-drawer--recommendations--loaded');
			})
			.catch(e => {
				console.error('Error fetching product recommendations:', e);
			});
	}

	initSwiper() {
		const swiperContainer = this.querySelector('.cart-drawer--recommendations--products');
		if (!swiperContainer) return;

		// Swiper wrapper oluştur
		const swiperWrapper = document.createElement('div');
		swiperWrapper.className = 'swiper-wrapper';
		
		// Mevcut ürün kartlarını swiper-slide içine al
		const products = swiperContainer.querySelectorAll('.collection-product-card, .product-card');
		products.forEach(product => {
			const slide = document.createElement('div');
			slide.className = 'swiper-slide';
			slide.appendChild(product.cloneNode(true));
			swiperWrapper.appendChild(slide);
		});

		// Eski içeriği temizle ve swiper yapısını oluştur
		swiperContainer.innerHTML = '';
		swiperContainer.classList.add('swiper');
		swiperContainer.appendChild(swiperWrapper);

		// Swiper'ı initialize et
		if (typeof Swiper !== 'undefined') {
			const navPrev = this.querySelector('.cart-drawer--recommendations--nav-prev');
			const navNext = this.querySelector('.cart-drawer--recommendations--nav-next');
			
			new Swiper(swiperContainer, {
				slidesPerView: 'auto',
				spaceBetween: 12,
				slidesPerView: 2.5,
				freeMode: true,
				navigation: {
					nextEl: navNext,
					prevEl: navPrev,
				}
			});
		}
	}

	connectedCallback() {
		// Sayfa yüklendiğinde direkt fetch et
		this.fetchProducts();
	}
}
if (!customElements.get('product-recommendations-drawer')) {
	customElements.define('product-recommendations-drawer', ProductRecommendationsDrawer);
}
